import { Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';
import { EnumGenericRoleActionAlerts } from '@pages/BasePage';

@Component({
    selector: 'app-compare-files',
    templateUrl: './compare-files.component.html',
    styleUrls: ['./compare-files.component.scss'],
})
export class CompareFilesModalComponent implements OnInit, OnDestroy {

    public Files: { url: string; name?: string }[] = [];

    public IsFullscreen: boolean = false;

    private onFullscreenChange = () => {

        // Sincroniza apenas quando o fullscreen nativo do browser é encerrado por fora
        // (ex: tecla Esc) sem passar pelo botão — nesse caso também recolhe a modal.
        if (!document.fullscreenElement && this.IsFullscreen) {
            this.IsFullscreen = false;
            this.getModalElement()?.classList.remove('max');
        }
    };

    constructor(
        private ModalController: ModalController,
        private NavParams: NavParams,
        private ElementRef: ElementRef
    ) {

        this.Files = this.NavParams.get('files') || [];
    }

    ngOnInit() {
        document.addEventListener('fullscreenchange', this.onFullscreenChange);
    }

    ngOnDestroy() {
        document.removeEventListener('fullscreenchange', this.onFullscreenChange);

        if (document.fullscreenElement) document.exitFullscreen().catch(() => { });
    }

    private getModalElement(): HTMLElement {
        return this.ElementRef.nativeElement.closest('ion-modal');
    }

    async ToggleFullscreen() {

        const modalEl = this.getModalElement();

        this.IsFullscreen = !this.IsFullscreen;

        // 'max' é a classe do tema (ion-modal.full.max, ver theme/ionic/modal.scss) que força
        // --width/--height/--max-width/--max-height a 100% mesmo no breakpoint >=1200px, onde
        // '.full' sozinha mantém margens. É sempre aplicada, independente da Fullscreen API do
        // browser ter sucesso (pode falhar por permissões/contexto).
        modalEl?.classList.toggle('max', this.IsFullscreen);

        try {

            if (this.IsFullscreen && !document.fullscreenElement) {
                await (modalEl || document.documentElement).requestFullscreen();
            }
            else if (!this.IsFullscreen && document.fullscreenElement) {
                await document.exitFullscreen();
            }
        }
        catch { }
    }

    Close() {
        this.ModalController.dismiss(null, EnumGenericRoleActionAlerts.Close);
    }

}
